import { compose } from '@reduxjs/toolkit';
import { withFormPlayer } from '../Player';
import Playback from './Playback';

const enhance = compose(withFormPlayer);

export default enhance(Playback);
